import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Button from "components/library/Button";

import { saveDeepDiveForm } from "deepDiveEditor/actions/form";

const mapStateToProps = state => ({
  isSaving: state.deepDiveEditor.status.isSaving,
  isDirty: state.deepDiveEditor.status.isDirty,
});

const mapDispatchToProps = {
  saveDeepDiveForm,
};

function SaveButton(props) {
  const buttonText = !props.isDirty
    ? "Saved"
    : props.isSaving
    ? "Saving"
    : "Save";

  return (
    <Button
      className="gtm-save-deep-dive"
      onClick={props.saveDeepDiveForm}
      isDisabled={!props.isDirty || props.isSaving}
      type="tertiary"
      data-cy="saveDeepDiveButton"
    >
      {buttonText}
    </Button>
  );
}

SaveButton.propTypes = {
  isSaving: PropTypes.bool.isRequired,
  isDirty: PropTypes.bool.isRequired,
  saveDeepDiveForm: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SaveButton);
